import { useState, useCallback } from 'react';

export function useShowAllGroups(initial = false) {
  const [showAllGroups, setShowAllGroups] = useState(initial);

  const toggleShowAllGroups = useCallback(() => {
    setShowAllGroups(v => !v);
  }, []);

  const resetShowAllGroups = useCallback(() => {
    setShowAllGroups(initial);
  }, [initial]);

  return { showAllGroups, toggleShowAllGroups, resetShowAllGroups };
}
